import { Button, Colors, Icon, Intent, Portal } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { ScrollParent } from "@/components/layout/ScrollParent";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { LoadingOverlay } from "@/components/pieces/loading/LoadingOverlay";
import { Overlay } from "@/components/pieces/overlay/Overlay";
import { BRAND_PURPLE } from "@/css/constants";

interface MobileActionPopupProps {
  actionDisabled?: boolean;
  actionText: string;
  context?: React.ReactNode;
  intent?: Intent;
  loading: boolean;
  onAction: () => void;
  onCancel: () => void;
  title: string;
  visible: boolean;
}

export function MobileActionPopup({
  actionDisabled,
  actionText,
  context,
  intent = "primary",
  loading,
  onAction,
  onCancel,
  title,
  visible,
}: MobileActionPopupProps) {
  return (
    <Portal>
      <Overlay
        top="auto"
        visible={visible}
        onClose={onCancel}
        style={{
          width: "100%",
          height: "100%",
          zIndex: 500,
        }}
      >
        <Box
          opacity={0.8}
          bg={Colors.DARK_GRAY2}
          width={1}
          height="100%"
          style={{
            top: 0,
            left: 0,
            zIndex: 1100,
            position: "absolute",
          }}
        />
        <Flex width={1} height="100%" flexDirection="column" flexWrap="nowrap">
          <Box mt="auto" style={{ zIndex: 1500 }}>
            <Flex
              width={1}
              p={3}
              style={{
                bottom: 0,
                color: Colors.DARK_GRAY2,
                fontWeight: "600",
                backgroundColor: Colors.WHITE,
                width: "100%",
                boxShadow: "0px -3px 4px rgba(86, 66, 166, 0.1)",
                borderRadius: "8px 8px 0px 0px",
                borderBottom: `1px solid ${Colors.LIGHT_GRAY3}`,
              }}
            >
              <Box textAlign="center" flexGrow="1" color={Colors.DARK_GRAY3}>
                <span style={{ paddingLeft: "13px", fontWeight: 600 }}>
                  {title}
                </span>
              </Box>
              <Flex
                flexBasis="26px"
                flexShrink="0"
                alignItems="center"
                justifyContent="center"
              >
                <Clickable
                  onClick={() => {
                    if (!loading) {
                      onCancel();
                    }
                  }}
                >
                  <Icon icon="cross" size={20} color={Colors.GRAY3} />
                </Clickable>
              </Flex>
            </Flex>
            <Box
              style={{
                position: "relative",
                overflowX: "hidden",
              }}
              height="100%"
              width="100%"
            >
              <ScrollParent
                style={{ backgroundColor: Colors.WHITE, overflowY: "auto" }}
              >
                <Box px={2} py="24px">
                  {context}
                  <Flex justifyContent="flex-start" mt={5}>
                    <Button
                      disabled={actionDisabled}
                      large={true}
                      text={actionText}
                      fill={true}
                      intent={Intent.PRIMARY}
                      style={{
                        backgroundColor: BRAND_PURPLE,
                      }}
                      onClick={onAction}
                    />
                  </Flex>
                  {loading && <LoadingOverlay intent={intent} />}
                </Box>
              </ScrollParent>
            </Box>
          </Box>
        </Flex>
      </Overlay>
    </Portal>
  );
}
